(() => {
  const simplify = () => {
    const form = document.querySelector(
      'cod-cart-checkout .cod-cart-checkout__domestic form'
    );

    if (!form) return;

    ['address', 'note'].forEach((name) => {
      const field = form.querySelector(`[name="${name}"]`);
      const row = field?.closest('.cod-cart-checkout__row');

      if (row) row.remove();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      simplify,
      { once: true }
    );
  } else {
    simplify();
  }

  document.addEventListener(
    'shopify:section:load',
    simplify
  );
})();